import {
  SidebarHeader,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuButton,
  useSidebar,
} from '@predoc/cow';
import { Link } from 'react-router';
import { useBranding } from '@/hooks';

export const AppSidebarHeader = () => {
  const { open } = useSidebar();
  const brand = useBranding();

  return (
    <SidebarHeader>
      <SidebarMenu>
        <SidebarMenuItem>
          <SidebarMenuButton size="lg" asChild>
            <Link to="/">
              {brand.sidebarSwap ? (
                open ? (
                  <img
                    src={brand.sidebarText}
                    alt={brand.name}
                    className="h-8 object-contain"
                  />
                ) : (
                  <img
                    src={brand.sidebarIcon}
                    alt={brand.name}
                    className="h-8 w-8 object-contain"
                  />
                )
              ) : (
                <>
                  <img
                    src={brand.sidebarIcon}
                    alt={brand.name}
                    className="h-8"
                  />
                  {open ? (
                    <img
                      src={brand.sidebarText}
                      alt={brand.name}
                      className="ml-2 h-8"
                    />
                  ) : null}
                </>
              )}
            </Link>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarHeader>
  );
};
